export const getUriWithoutPath = anyUri => {
  if (!anyUri) {
    return undefined;
  }
  const port = anyUri.port();
  const portToConcat = port ? ":".concat(port) : "";
  const uriWithoutPath = "".concat(anyUri.protocol(), "://").concat(anyUri.hostname()).concat(portToConcat, "/");
  return uriWithoutPath;
};